import './App.css';
import { Analytics } from '@vercel/analytics/react';
import { SpeedInsights } from '@vercel/speed-insights/react';

function App() {
  return (
    <div className="App">
      {/* Hero Section */}
      <section className="hero">
        <h1>Nathan McCarley</h1>
        <h2>Alternative Data Engineer</h2>
        <p className="bio">
          I build AI systems that turn unconventional data into actionable intelligence. 
          From social network analysis to real estate development patterns, I create 
          production-scale platforms that extract insights from chaos.
        </p>
      </section>

      {/* Technical Expertise */}
      <section className="technical-expertise">
        <div className="section-container">
          <h3>Technical Expertise</h3>
          <ul className="expertise-list">
            <li><strong>Multi-Agent AI Systems</strong> - Orchestrated research pipelines with 1,500x cost optimization</li>
            <li><strong>Alternative Data Platforms</strong> - Real estate intelligence serving Fortune 500 companies</li>
            <li><strong>Browser Automation</strong> - Novel agentic browser element interaction system for dynamic website tasks</li>
            <li><strong>Voice AI Systems</strong> - Conversational interfaces with behavioral optimization</li>
            <li><strong>Mathematical Modeling</strong> - Applied graph theory, Markov chains, and matrix factorization to organizational systems</li>
          </ul>
        </div>
      </section>

      {/* Key Projects */}
      <section className="key-projects">
        <div className="section-container">
          <h3>Key Projects</h3>
          
          <div className="project">
            <h4>LandScout - Real Estate Development Intelligence</h4>
            <p>Built alternative data platform tracking 16+ permit types across an estimated 1,000+ US counties with overnight updates. Validated with regional managers at Lennar, Pulte, and D.R. Horton. $300K+ revenue pipeline identified.</p>
          </div>

          <div className="project">
            <h4>Agent Swarm Research System</h4>
            <p>Designed 7-component autonomous AI research pipeline achieving 1,500x cost reduction through proprietary RAG optimizations. Built before Perplexity existed - ahead of industry trends.</p>
          </div>

          <div className="project">
            <h4>Browser Automation Infrastructure</h4>
            <p>Built intelligent web automation system combining LLM-powered webpage analysis with production-scale document extraction. System uses a combination of agents (originally just GPT-4o) to dynamically identify and interact with webpage elements, eliminating the brittleness of traditional CSS selectors.</p>
          </div>

          <div className="project">
            <h4>Contact Validation Platform</h4>
            <p>AI-powered verification system integrating skip tracing, voice calls via Retell API, and LLM-based conversation analysis for lead qualification.</p>
          </div>

          <div className="project">
            <h4>AIMS - Organizational Intelligence</h4>
            <p>Applied collaborative filtering, social network analysis, and Markov chain modeling to optimize 200-person fraternity operations. Netflix-style task recommendations with influence detection algorithms.</p>
          </div>
        </div>
      </section>

      {/* Professional Experience */}
      <section className="experience">
        <div className="section-container">
          <h3>Professional Experience</h3>
          
          <div className="job">
            <h4>SVP of Technology | InfoScout</h4>
            <span className="date">(2024-2025)</span>
            <ul>
              <li>Led 8-engineer team from Stanford, CMU, Berkeley, UCSD, UNC, and UVA developing AI-powered research systems</li>
              <li>Architected multi-agent pipelines processing thousands of research operations daily</li>
              <li>Achieved 1,500x cost optimization through algorithmic improvements</li>
            </ul>
          </div>

          <div className="job">
            <h4>Vice President | Delta Chi Fraternity</h4>
            <span className="date">(2021-2023)</span>
            <ul>
              <li>Designed AI house management system with computer vision inventory tracking</li>
              <li>Designed market-based task allocation with dynamic pricing algorithms</li>
              <li>Managed $80,000+ annual budget with automated purchasing constraints</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Education */}
      <section className="education">
        <div className="section-container">
          <h3>Education</h3>
          <div className="degree">
            <h4>University of North Carolina Chapel Hill</h4>
            <p>B.S. Physics, Mathematics Minor, Quantitative Finance Concentration (2023)</p>
          </div>
        </div>
      </section>

      {/* Achievements */}
      <section className="achievements">
        <div className="section-container">
          <h3>Achievements</h3>
          <ul>
            <li>Semi-finalist, Triangle Ventures Pitch Competition ($500K funding competition)</li>
            <li>1,500x cost optimization in production AI systems</li>
            <li>Fortune 500 customer validation in real estate intelligence</li>
            <li>Team leadership: 8 engineers from top-tier universities</li>
          </ul>
        </div>
      </section>

      {/* Contact */}
      <section className="contact">
        <div className="section-container">
          <h3>Contact</h3>
          <div className="contact-info">
            <p><strong>Location:</strong> Available for NYC-based roles</p>
            <p><strong>Email:</strong> <a href="mailto:nrmccarley@gmail.com">nrmccarley@gmail.com</a></p>
            <p><strong>LinkedIn:</strong> <a href="https://www.linkedin.com/in/nathan-mccarley-a47270253/" target="_blank" rel="noopener noreferrer">https://www.linkedin.com/in/nathan-mccarley-a47270253/</a></p>
            <p><strong>GitHub:</strong> <a href="https://github.com/NRMcCarley" target="_blank" rel="noopener noreferrer">https://github.com/NRMcCarley</a></p>
          </div>
        </div>
      </section>

      <Analytics mode="auto" />
      <SpeedInsights />
    </div>
  );
}

export default App;
